import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';

export declare class Criteria {
  statuses: string[];
  dateFrom?: Date;
  dateTo?: Date;

  client?: string;
  practitioner?: string;
  diagnosis?: string;
  conclusion?: string;
}

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FilterPanelComponent implements OnInit {

  readonly criteriaEventEmitter: EventEmitter<Criteria> = new EventEmitter<Criteria>();

  // checkedStatuses: string[] = [];
  // dateFrom: Date;
  // dateTo: Date;
  // client: string;
  criteria: Criteria = {statuses: ['NEW', 'ACTIVE', 'DONE', 'CLOSED']};

  constructor() { }

  ngOnInit() {
  }

  selectStatuses(statuses: string[]) {
    this.criteria.statuses = statuses;
    this.emitChange();
  }

  dateFromChanged(date: Date) {
    this.criteria.dateFrom = date;
    this.emitChange();
  }

  dateToChanged(date: Date) {
    this.criteria.dateTo = date;
    this.emitChange();
  }

  clientChanged(client: string) {
    this.criteria.client = client;
    this.emitChange();
  }

  practitionerChanged(practitioner: string) {
    this.criteria.practitioner = practitioner;
    this.emitChange();
  }

  diagnosisChanged(diagnosis: string) {
    this.criteria.diagnosis = diagnosis;
    this.emitChange();
  }

  conclusionChanged(conclusion: string) {
    this.criteria.conclusion = conclusion;
    this.emitChange();
  }

  private emitChange() {
    this.criteriaEventEmitter.emit(this.criteria);
  }
}
